export default "assets/images/texture_footer-f7653e2b.png";